<template>
  <div  v-if="loading === false && this.product">
  <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')" style="min-height: calc(100vh - 20px);">
    <!-- header -->
    <HeaderBackMobile />
    
    <!-- promo label -->
    <b-row v-if="product.product_views[currentViewIdx].promotional_price"  style="margin-top:21px;height:48px;">
      <b-col>
        <svg  style="position:absolute;left:0;z-index:1;" width="182" height="48" viewBox="0 0 182 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H176.115C179.9 0 182.312 4.04109 180.517 7.37231L159.469 46.4234C158.945 47.3945 157.931 48 156.828 48H0V0Z" fill="url(#paint0_linear)"/>
          <defs>
            <linearGradient id="paint0_linear" x1="0" y1="24" x2="180" y2="24" gradientUnits="userSpaceOnUse">
            <stop :stop-color="getCssColor('primary_bt')"/>
            <stop offset="1" :stop-color="getCssColor('secondary_bt')"/>
            </linearGradient>
          </defs>
        </svg>
        <span style="position:absolute;z-index:2;top:10px;" class="labelPromotionMobile">
          {{ Math.round(100 - ((product.product_views[currentViewIdx].promotional_price / product.product_views[currentViewIdx].price) * 100))}}%
           DE DESCONTO</span>
      </b-col>
    </b-row>

    <!-- images -->
    <b-row style="margin-top:21px;">
      <b-col style="margin: 0 15px;text-align:center;">
        <img @error="imgUrlAlt" :src="getProductImage()" :alt="product.name" style="max-height:200px;max-width:100%" />
        <AtacarejoSticker style="right:18px;bottom:10px;" :productView='product.product_views[currentViewIdx]'/>
      </b-col>
    </b-row>

    <!-- img bullets -->
    <b-row v-if="product.photos.length > 1" style="margin-top:21px;">
      <b-col style="margin: 0 15px;height:12px;line-height:10px;width:100%;padding:0px;">
        <div style="margin: 0 auto;min-width:60px;height:10px;text-align:center;">
          <div style="width:10px;height:10px;border-radius:5px;background-color:#B8B8B8;margin:0 5px;display:inline-block;"></div>
          <div style="width:10px;height:10px;border-radius:5px;background-color:rgba(184, 184, 184, 0.45);margin:0 5px;display:inline-block;"></div>
          <div style="width:10px;height:10px;border-radius:5px;background-color:rgba(184, 184, 184, 0.45);margin:0 5px;display:inline-block;"></div>
        </div>
      </b-col>
    </b-row>

    <b-row style="margin-top:21px;">
      <b-col style="margin: 0 15px;border-bottom:1px solid #F7F7F8;">
      </b-col>
    </b-row>

    <!-- name -->
    <b-row style="margin-top:21px;">
      <b-col style="margin: 0 15px;">
        <div class="productNameMobile">
          {{(product.product_views[currentViewIdx].name).toLowerCase()}}
        </div>
      </b-col>
    </b-row>

    <!-- EAN -->
    <b-row style="margin-top:5px;" v-if="product.product_views[currentViewIdx].ean">
      <b-col style="margin: 0 15px;">
        <div class="productEANMobile">
          EAN: {{(product.product_views[currentViewIdx].ean)}}
        </div>
      </b-col>
    </b-row>

    <!-- promo price -->
    <b-row style="margin-top:15px;">
      <b-col v-if="product.product_views[currentViewIdx].promotional_price" cols="12" style="margin: 0 15px;">
        <span style="
          font-style: normal;
          font-weight: normal;
          line-height: 20px;
          font-size: 14px;
          letter-spacing: 0.25px;
          text-decoration: line-through;
          color: #969696;">De: R$ {{formatPrice(product.product_views[currentViewIdx].price)}}</span>
      </b-col>

      <!-- price -->
      <b-col cols="12" style="margin: 6px 15px 0 15px;">
        <span 
          :style="{color: getCssColor('primary_bt')}"
          style="
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          font-size: 24px;
          ">
            Por: R$ 
            <template v-if="product.product_views[currentViewIdx].promotional_price">
            {{formatPrice(product.product_views[currentViewIdx].promotional_price)}}
            </template>
            <template v-else>
            {{formatPrice(product.product_views[currentViewIdx].price)}}
            </template>
          </span>
      </b-col>
    </b-row>

    <!-- atacarejo -->
    <b-row align-h="center" style="margin-top:21px;color:#555;" v-if="product.product_views[currentViewIdx].promotional_conditionals && product.product_views[currentViewIdx].promotional_conditionals.length" >
      <b-col cols="11" style="font-weight:500;">
        Preço de Atacado
      </b-col>
      <b-col cols="10">
        <b-row style="border-bottom:1px solid #f7f7f8;font-weight:500;">
          <b-col>A Partir de</b-col>
          <b-col>Preço</b-col>
        </b-row>
        <b-row style="border-bottom:1px solid #f7f7f8;" v-for="(atac, idxatac) in product.product_views[currentViewIdx].promotional_conditionals" v-bind:key="idxatac">
          <b-col>{{atac.number_of_products_to_promo}} unidades</b-col>
          <b-col>R$ {{formatPrice(atac.promotional_conditional_price)}}</b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- product presentations -->
    <b-row v-if="product.presentations.length > 0" style="margin-top:15px;">
      <b-col v-for="(presentation, idxp) in product.presentations" v-bind:key="idxp" cols="12" style="padding:0 30px;margin-top:6px;">
        <b-row style="padding: 0 15px;" @click="openOptionModal(presentation)">
          <b-col style="line-height:17px;">
            <span style="
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            color: #121C2A;
            ">{{presentation.name}}</span><br/>
            <span style="
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            color: #525962;
            ">{{getSelectedOptionName(presentation)}}</span>
          </b-col>
          <b-col cols="2" style="line-height:34px;margin-top:3px;">
            <div v-if="getSelectedOptionImage(presentation)" style="width:34px;height:34px;border-radius:17px;">
              <img @error="imgUrlAlt" :src="getSelectedOptionImage(presentation)" style="max-width:34px;max-height:34px;"/>
            </div>
            <div v-else-if="getSelectedOptionColor(presentation)" :style="{backgroundColor:getSelectedOptionColor(presentation)}" style="width:34px;height:34px;border-radius:17px;"></div>
          </b-col>
          <b-col cols="2" style="line-height:34px;text-align:center;">
            <div style="cursor:pointer;">
            <font-awesome-icon style="font-size:22px;color: #525962;margin-top:8px;"  :icon="['fal', 'chevron-right']"/>
            </div>
          </b-col>
        </b-row>
        <b-row style="margin: 0px;border-bottom:1px solid #f7f7f8;height:8px;"></b-row>
      </b-col>

    </b-row>

    <b-row v-if="product.description" style="margin-top:21px;">
      <b-col style="margin: 0 15px;">
          <div style="
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            font-size: 17px;
            letter-spacing: 0.15px;
            color: #121C2A;
          "> Descrição</div>
      </b-col>
    </b-row>

    <b-row v-if="product.description"  style="margin-top:15px;">
      <b-col style="margin: 0 15px;">
          <div class="productDescriptionMobile" v-html="parseProductDescription(product.description)"></div>
      </b-col>
    </b-row>
    
    <!-- presentation modal -->
    <div :class="{optionsModalOpenned:optionsModal, optionsModal:!optionsModal}" style="position:fixed;top:0px;z-index:21000;background-color:#ffffff;">
      <b-container v-if="tempOptions">
        <b-row class="headerBackCart" style="height:60px;" :style="{backgroundColor: getCssColor('bg_header')}">
          <b-col cols="2" style="height:60px;line-height:60px;">
            <div @click="optionsModal=false" style="cursor:pointer;" :style="{color: getCssColor('primary_bt')}">
              <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'chevron-left']"/>
            </div>
          </b-col>
          <b-col style="height:60px;line-height:54px;font-weight:500;">
            SELECIONE {{(tempOptions.name).toUpperCase()}}
          </b-col>
        </b-row>
        <b-row @click="selectOption(tempOptions, option)" v-for="(option, idxOpt) in tempOptions.options" v-bind:key="idxOpt" style="border-bottom:1px solid #c0c0c0;padding:10px;">
          <b-col style="line-height:40px;font-weight:300;font-size:16px;">
            <b>{{option.label}}</b>
          </b-col>
          <b-col cols="3">
            <div v-if="option.img" style="width:42px;height:42px;border-radius:17px;">
              <img @error="imgUrlAlt" :src="productImageURI + '/' + $store.state.company.companyId  + '/' + option.img" style="max-width:42px;max-height:42px;"/>
            </div>
            <div v-else-if="option.color" :style="{backgroundColor:option.color}" style="width:42px;height:42px;border-radius:21px;margin-top:3px"></div>
          </b-col>
          <b-col cols="2" style="line-height:40px;text-align:center;">
            <div style="cursor:pointer;margin-top:5px;" :style="{color: getCssColor('header_icon_color')}">
              <font-awesome-icon :style="{color: (tempOptions.selectecOption.id === option.id ? getCssColor('primary_bt') : '#c0c0c0')}" style="font-size:24px;"  :icon="['far', 'check']"/>
            </div>
          </b-col>
        </b-row>

      </b-container>
    </div>

    <!-- fixed buy now button -->
    <div class="row" style="height:90px;"></div>
    <div class="row" style="position:fixed;bottom:0px;width:100%;height:81px;background-color:#F5F6F7;">
      <template v-if="hasCombination">
      <div  v-if="!isOnCart(product.id, product.product_views[currentViewIdx].id)"
      @click="addToCart(product, product.product_views[currentViewIdx].id)"
      :style="{backgroundColor: getCssColor('primary_bt')}"
      style="
      margin:15px auto;
        width:calc( 100% - 30px);height:48px;
        line-height:48px;
        border-radius:4px;
        text-align:center;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        text-transform: uppercase;
        color: #FFFFFF;">COMPRAR</div>
        <b-col v-else style="margin: 24px 0;height:60px;">
          <b-row align-h="center" style="line-height:20px;height:28px;">
            <b-col cols="2" style="text-align:center;line-height:28px;" @click="minusQtd(product.id, product.product_views[currentViewIdx].id); $forceUpdate()">
              <font-awesome-icon v-if="getQtd(product.id, product.product_views[currentViewIdx].id) > 1" style="cursor:pointer;font-size:28px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'minus-circle']"/>
              <font-awesome-icon v-else style="cursor:pointer;font-size:28px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'trash-alt']"/>
            </b-col>
            <b-col cols="2" style="text-align:center;font-size:20px;line-height:28px;" >{{getQtd(product.id, product.product_views[currentViewIdx].id)}}</b-col>
            <b-col cols="2" style="text-align:center;line-height:28px;" @click="plusQtd(product.id, product.product_views[currentViewIdx].id)">
              <font-awesome-icon style="cursor:pointer;font-size:28px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'plus-circle']"/>
            </b-col>
          </b-row>
        </b-col>
      </template>
      <template v-else>
        <div style="
          background-color: #c0c0c0;
          margin:15px auto;
          width:calc( 100% - 30px);height:48px;
          line-height:48px;
          border-radius:4px;
          text-align:center;
          font-style: normal;
          font-weight: 600;
          font-size: 15px;
          text-transform: uppercase;
          color: #FFFFFF;">ESGOTADO</div>
      </template>
    </div>

  </b-container>


  <!-- DESKTOP VIEW -->


  <b-container fluid v-else style="min-height:100vh;background-color:#F5F6F7;">
    <b-row>
      <StoreHeader />
    </b-row>
    <b-row style="margin-top:10px;padding-bottom:50px;min-height:500px;" class="justify-content-md-center">
      <b-col cols="7">
        <b-row style="padding:10px;">
          <b-col class="shadowDeskBox" style="border-radius:3px; background-color:#ffffff;height:100%;text-align:center;">
              <img @error="imgUrlAlt" :src="getProductImage()" :alt="product.name" style="margin-top:10px;max-height:440px;max-width:100%" />
              <AtacarejoSticker style="right:30px;top:30px;" :productView='product.product_views[currentViewIdx]' :big="true"/>
            <b-row v-if="product.description">
              <b-col style="
              border-bottom: 1px solid #CDCDCD;
              margin:40px;
              "/>
            </b-row>
            <b-row v-if="product.description" style="text-align:left; padding:0 30px;">
                <b-col style="
                  font-style: normal;
                  font-weight: 500;
                  line-height: 20px;
                  font-size: 24px;
                  letter-spacing: 0.15px;
                  color: #121C2A;
                  margin: 20px 0;
                ">Descrição</b-col>
              </b-row>
              <b-row style="padding:0 30px; padding-bottom:40px;text-align:left;">
                <b-col>
                  <div class="productDescriptionDesktop" v-html="parseProductDescription(product.description)"></div>
                </b-col>
              </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-row style="padding:10px;">
          <b-col class="shadowDeskBox" style="padding: 5px 30px;border-radius:3px; background-color:#ffffff;height:100%;">
            <b-row style="margin-top:20px;">
              <b-col class="productNameDesktop">{{(product.name).toLowerCase()}}</b-col>
            </b-row>

            <b-row style="margin-top:5px;" v-if="product.product_views[currentViewIdx].ean">
              <b-col class="productEANDesktop">EAN: {{(product.product_views[currentViewIdx].ean)}}</b-col>
            </b-row>

            <!-- promo label -->
            <b-row v-if="product.product_views[currentViewIdx].promotional_price"  style="margin-top:15px;height:48px;">
              <b-col>
                <svg   style="position:absolute;left:-15px;z-index:1;" width="182" height="48" viewBox="0 0 182 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H176.115C179.9 0 182.312 4.04109 180.517 7.37231L159.469 46.4234C158.945 47.3945 157.931 48 156.828 48H0V0Z" fill="url(#paint0_linear)"/>
                  <defs>
                    <linearGradient id="paint0_linear" x1="0" y1="24" x2="180" y2="24" gradientUnits="userSpaceOnUse">
                    <stop :stop-color="getCssColor('primary_bt')"/>
                    <stop offset="1" :stop-color="getCssColor('secondary_bt')"/>
                    </linearGradient>
                  </defs>
                </svg>
                <span style="position:absolute;z-index:2;top:10px;" class="labelPromotionMobile">
                  {{ Math.round(100 - ((product.product_views[currentViewIdx].promotional_price / product.product_views[currentViewIdx].price) * 100))}}%
                  DE DESCONTO</span>
              </b-col>
            </b-row>

            <b-row style="margin-top:15px;">
              <b-col cols="12" v-if="hasCombination && product.product_views[currentViewIdx].promotional_price" style="
              font-style: normal;
              font-weight: normal;
              line-height: 20px;
              font-size: 14px;
              letter-spacing: 0.1px;
              margin-bottom:8px;
              text-decoration: line-through;
              color: #969696;
              ">R$ {{formatPrice(product.product_views[currentViewIdx].price)}}</b-col>
              <b-col cols="12" 
              :style="{color: getCssColor('primary_bt')}"
              style="
              font-style: normal;
              font-weight: normal;
              line-height: 40px;
              font-size: 34px;
              letter-spacing: 0.25px;
              ">R$ 
                <template v-if="product.product_views[currentViewIdx].promotional_price">
                {{formatPrice(product.product_views[currentViewIdx].promotional_price)}}
                </template>
                <template v-else>
                {{formatPrice(product.product_views[currentViewIdx].price)}}
                </template>
              </b-col>
            </b-row>

            <!-- atacarejo -->
            <b-row align-h="center" style="margin-top:21px;color:#555;" v-if="product.product_views[currentViewIdx].promotional_conditionals && product.product_views[currentViewIdx].promotional_conditionals.length" >
              <b-col cols="12" style="font-weight:500;">
                Preço de Atacado
              </b-col>
              <b-col cols="11">
                <b-row style="border-bottom:1px solid #f7f7f8;font-weight:500;">
                  <b-col>A Partir de</b-col>
                  <b-col>Preço</b-col>
                </b-row>
                <b-row style="border-bottom:1px solid #f7f7f8;" v-for="(atac, idxatac) in product.product_views[currentViewIdx].promotional_conditionals" v-bind:key="idxatac">
                  <b-col>{{atac.number_of_products_to_promo}} unidades</b-col>
                  <b-col>R$ {{formatPrice(atac.promotional_conditional_price)}}</b-col>
                </b-row>
              </b-col>
            </b-row>
            
             <!-- product presentations -->
            <b-row v-if="product.presentations.length > 0" >
              <b-col v-for="(presentation, idxp) in product.presentations" v-bind:key="idxp" cols="12" style="margin-top:15px;">
                <b-row >
                  <b-col style="line-height:17px;">
                    <span style="
                    font-style: normal;
                    font-weight: normal;
                    line-height: 20px;
                    font-size: 17px;
                    letter-spacing: 0.15px;
                    color: #121C2A;
                    ">{{presentation.name}}:</span>
                  </b-col>
                </b-row>
                <b-row style="margin-top:15px;">
                  <b-col>
                    <b-row style="padding: 0 15px;">
                      <b-col v-for="(option, idxo) in presentation.options" v-bind:key="idxo"
                        :style="{border: getSelectedOptionBorder(presentation, option)}" style="border-radius:3px;cursor:pointer;"
                        @click="selectOption(presentation, option)"
                      >
                        <b-row v-if="option.img || option.color" style="height:50px;" align-h="center">
                          <b-col style="padding:3px;">
                            <div v-if="option.img" style="width:42px;height:42px;border-radius:17px;margin:0 auto;">
                              <img @error="imgUrlAlt" :src="productImageURI + '/' + $store.state.company.companyId  + '/' + option.img" style="max-width:42px;max-height:42px;"/>
                            </div>
                            <div v-else-if="option.color" :style="{backgroundColor:option.color}" style="margin:0 auto;width:42px;height:42px;border-radius:21px;margin-top:3px"></div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col style="
                            font-style: normal;
                            font-weight: normal;
                            line-height: 20px;
                            font-size: 14px;
                            letter-spacing: 0.15px;
                            color: #121C2A;
                            text-align:center;
                          ">{{option.label}}</b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>


            <!-- buy button -->
            <b-row style="margin-top:20px;">
              <!-- not on cart -->
              <template v-if="hasCombination">
              <b-col  v-if="!isOnCart(product.id, product.product_views[currentViewIdx].id)"
              @click="addToCart(product, product.product_views[currentViewIdx].id)"
              :style="{backgroundColor: getCssColor('primary_bt')}"
              style="
                cursor:pointer;
                margin:30px 15px;
                width:calc( 100% - 30px);
                max-width:311px;
                height:48px;
                line-height:48px;
                border-radius:4px;
                font-style: normal;
                font-weight: 600;
                font-size: 15px;
                text-align: center;
                text-transform: uppercase;
                color: #FFFFFF;">COMPRAR</b-col>
                <!-- on cart -->
                <b-col v-else style="margin: 30px 0px;">
                  <b-row style="line-height:20px;height:20px;">
                    <b-col cols="2" style="text-align:center;line-height:30px;" @click="minusQtd(product.id, product.product_views[currentViewIdx].id); $forceUpdate()">
                      <font-awesome-icon v-if="getQtd(product.id, product.product_views[currentViewIdx].id) > 1" style="cursor:pointer;font-size:30px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'minus-circle']"/>
                      <font-awesome-icon v-else style="cursor:pointer;font-size:30px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'trash-alt']"/>
                    </b-col>
                    <b-col cols="2" style="text-align:center;font-size:24px;line-height:30px;" >{{getQtd(product.id, product.product_views[currentViewIdx].id)}}</b-col>
                    <b-col cols="2" style="text-align:center;line-height:30px;" @click="plusQtd(product.id, product.product_views[currentViewIdx].id)">
                      <font-awesome-icon style="cursor:pointer;font-size:30px;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'plus-circle']"/>
                    </b-col>
                  </b-row>
                </b-col>
                </template>
                <!-- no combination -->
                <template v-else>
                <b-col 
                  style="
                    background-color: #c0c0c0;
                    cursor:pointer;
                    margin:30px 15px;
                    width:calc( 100% - 30px);
                    max-width:311px;
                    height:48px;
                    line-height:48px;
                    border-radius:4px;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 15px;
                    text-align: center;
                    text-transform: uppercase;
                    color: #FFFFFF;">ESGOTADO</b-col>
                </template>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <Footer />
    </b-row>
  </b-container>
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
import cartMixin from '@/mixins/cartMixin'
import formaters from '@/mixins/formaters'
import colors from '@/mixins/colors'
import ProductsConn from '@/connection/productsv2.js'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import StoreHeader from '@/components/StoreHeader.vue'
import Footer from '@/components/Footer.vue'
import InnerLoading from '@/components/InnerLoading.vue'
import AtacarejoSticker from '@/components/AtacarejoSticker'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      defaultView: true,
      currentViewIdx: 0,
      loading: true,
      optionsModal: false,
      product: null,
      tempOptions: null,
      hasCombination: true
    }
  },

  components: {StoreHeader, HeaderBackMobile, InnerLoading, Footer, AtacarejoSticker},

  mixins: [navigation, colors, formaters, cartMixin],

  async created () {
    let p = await ProductsConn.getProductById(this.$route.params.productId)
    if (p) {
      this.product = p
      this.selectInitialOptionsView()
      this.changeProductView()
      this.$forceUpdate()
    } else {
      EventBus.$emit('showAlert', 'error', 'Erro ao obter produto')
      this.back()
    }
    console.log(this.product)
    this.loading = false
  },

  computed: {
    productImageURI () {
      return this.$store.getters.getProductImageURI
    }
  },

  methods: {
    getProductImage () {
      if (!this.product.has_presentation) {
        if (this.product.photos.length && this.product.photos[0].id) {
          return this.productImageURI + '/' + this.product.photos[0].id
        } else {
          return 'https://cdnimages.opa4.store/img/fixedimg/no-picture.png'
        }
      } else if (!this.defaultView) {
        if (this.product.product_views[this.currentViewIdx].photos && this.product.product_views[this.currentViewIdx].photos.length && 
          this.product.product_views[this.currentViewIdx].photos[0].id
        ) {
          return this.productImageURI + '/' + this.product.product_views[this.currentViewIdx].photos[0].id
        } else {
          return this.productImageURI + '/' + this.product.photos[0].id
        }
      } else {
        return this.productImageURI + '/' + this.product.photos[0].id
      }
    },
    
    openOptionModal (presentation) {
      this.tempOptions = presentation
      this.optionsModal = true
    },

    selectInitialOptionsView () {
      this.product.presentations.forEach((presentation) => {
        if (!presentation.selectecOption) {
          presentation.selectecOption = presentation.options[0]
        }
      })
    },

    getSelectedOptionName (presentation) {
      return presentation.selectecOption.label
    },

    getSelectedOptionColor (presentation) {
      return presentation.selectecOption.color
    },

    getSelectedOptionBorder (presentation, option) {
      if (presentation.selectecOption.id === option.id) {
        return '1px solid #CDCDCD'
      } else {
        return '1px solid #FFFFFF'
      }
    },

    getSelectedOptionImage (presentation) {
      if (!presentation.selectecOption) {
        presentation.selectecOption = presentation.options[0]
      }
      if (presentation.selectecOption.img) {
        return this.productImageURI + '/' + this.$store.state.company.companyId  + '/' + presentation.selectecOption.img
      } else {
        return null
      }
    },

    selectOption (presentation, option) {
      presentation.selectecOption = option
      this.changeProductView()
      this.optionsModal=false
      this.$forceUpdate()
    },

    changeProductView () {
      let returnToZero = true
      let selecteds = []
      this.product.presentations.forEach((p) => {
        selecteds.push(p.id + '_' + p.selectecOption.id)
      })
      for (let x = 0; x < this.product.product_views.length; x++) {
        let pvs = this.product.product_views[x].view
        let presentationString = ''
        for ( let z = 0; z < pvs.length; z ++ ) {
          presentationString = presentationString + '|' + pvs[z].presentation_id + '_' +  pvs[z].option_id
        }
        // all selecteds need to be present 
        let present = true
        for (let y = 0; y < selecteds.length; y++ ) {
          if (presentationString.indexOf(selecteds[y]) === -1 ){
            present = false
          }
        }
        if (present) {
          this.currentViewIdx = x
          returnToZero = false
          this.defaultView = false
          break;
        }
      }
      if (returnToZero) {
        this.currentViewIdx = 0
        this.defaultView = true
        this.hasCombination = false
      } else {
        this.hasCombination = true
      }
    },

    parseProductDescription (description) {
      if (description) {
        description = description.replace(/http:\/\//g, 'https://')
        description = description.replace(/width=".*"/g, '')
        description = description.replace(/height=".*"/g, '')
        return description
      }
      return null
    }
  }

}
</script>

<style lang="scss">
.productDescriptionMobile {
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  font-size: 14px;
  letter-spacing: 0.25px;
  text-align:justify;
  color: #525962;
  img {
    max-width:100%!important;
  }
}

.productDescriptionDesktop {

  font-style: normal;
  font-weight: normal;
  line-height: 27px;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: #525962;
  width: 100%!important;
  max-width:100%!important;

  img {
    max-width:100%!important;
  }

}
</style>

<style lang="scss" scoped>

.shadowDeskBox {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
}

.labelPromotionMobile {
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  font-size: 15px;
  text-align: center;
  text-transform: uppercase;

  color: #FFFFFF;
}



.headerBackCart {
  border-bottom:1px solid #CDCDCD;
}

.productNameMobile {
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  font-size: 17px;
  letter-spacing: 0.15px;
  color: #121C2A;
  text-transform: capitalize;
}

.productNameDesktop {
  font-style: normal;
  font-weight: normal;
  line-height: 28px;
  font-size: 24px;
  letter-spacing: 0.15px;
  color: #121C2A;
  text-transform: capitalize;
}

.productEANMobile{
  font-style: normal;
  line-height: 20px;
  font-size: 12px;
  letter-spacing: 0.15px;
  color: #555;
  text-transform: capitalize;
}

.productEANDesktop {
  font-style: normal;
  font-weight: normal;
  line-height: 28px;
  font-size: 16px;
  letter-spacing: 0.15px;
  color: #555;
  text-transform: capitalize;
}

.buyNow {
  width: 157px;
  text-align:center;
  border:1px solid;
  padding:5px;
  border-radius:4px;
  font-size:16px;
  font-weight:500;
  color:#ffffff;
  margin:20px auto;
  cursor:pointer;
}

.optionsModal {
    height: 100vh;
    width: 100vw;
    left:100vw;
    -webkit-transition: left 0.2s linear;
       -moz-transition: left 0.2s linear;
        -ms-transition: left 0.2s linear;
         -o-transition: left 0.2s linear;
            transition: left 0.2s linear;
}

.optionsModalOpenned {
  height: 100vh;
  width:100vw;
  left:0vw;
  -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
      -ms-transition: left 0.2s linear;
      -o-transition: left 0.2s linear;
          transition: left 0.2s linear;
}

</style>
